<template>
  <v-container>
    <v-dialog v-model="showDialog" max-width="750px" persistent>
      <v-card class='card'>
        <form>
          <v-card-title v-if="editingId == null">
            <h3>{{ $vuetify.t('$vuetify.AdminCategories.titleAdd') }}</h3>
          </v-card-title>
          <v-card-title v-else>
            <h3>{{ $vuetify.t('$vuetify.AdminCategories.titleEdit', name) }}</h3>
          </v-card-title>
          <v-card-text>
            <v-text-field
              name='name'
              v-model='name'
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              :label="this.$vuetify.t('$vuetify.AdminCategories.formName')"
              required/>

            <v-text-field
              name='description'
              v-model='description'
              :error-messages="errors.collect('description')"
              :label="this.$vuetify.t('$vuetify.AdminCategories.formDescription')"
              required/>

            <v-text-field
              name='position'
              v-model='position'
              v-validate="'required'"
              :label="this.$vuetify.t('$vuetify.AdminCategories.position')"
              :rules="[rules.numeric]"
              type="number"
              required/>

            <v-checkbox
              name='default'
              v-model='def'
              :error-messages="errors.collect('description')"
              :label="this.$vuetify.t('$vuetify.AdminCategories.isDefault')"
              required/>

            <!-- <v-avatar class='inlineinput' size='36'><img :src="formIconUrl" /></v-avatar> -->
            <vue-base64-file-upload
              accept="image/png,image/jpeg,image/svg"
              image-class="upload-image-preview"
              input-class="upload-image-input"
              :max-size="maxImageFileSize"
              @size-exceeded="onSizeExceeded"
              @load="onLoad"/>

            <!-- <upload-btn
              class='inlineinput'
              :title="this.$vuetify.t('$vuetify.AdminCategories.formPickIcon')"
              flat
              color="white"
              accept="image/*"
              :fileChangedCallback="handleIconSelected">
            </upload-btn> -->
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" :disabled="!isCategoryFormComplete || errors.any()" @click="this.submit"
                   v-if="this.editingId == null">
              {{ $vuetify.t('$vuetify.AdminCategories.formCreate', name) }}
            </v-btn>
            <v-btn color="primary" :disabled="!isCategoryFormComplete || errors.any()" @click="this.submit" v-else>
              {{ $vuetify.t('$vuetify.AdminCategories.formSave', name) }}
            </v-btn>
            <v-btn @click="closeDialog">
              {{ $vuetify.t('$vuetify.AdminCategories.formCancel', name) }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
      <FileSizeUploadErrorDialog ref="fileSizeUploadErrorDialog"/>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
// import UploadButton from 'vuetify-upload-button'
import VueBase64FileUpload from 'vue-base64-file-upload'
import FileSizeUploadErrorDialog from './FileSizeUploadErrorDialog'

export default {
  $_veeValidate: {validator: 'new'},
  name: 'CreateCategoryForm',
  props: {
    show: Boolean,
    category: Object
  },
  data: function () {
    return {
      name: '',
      description: '',
      editingId: null,
      position: null,
      def: false,
      image: '',
      iconFile: '',
      iconUrl: '',
      iconChanged: false,
      maxImageFileSize: 2, // in mb
      rules: {
        numeric: value => {
          const pattern = /^[0-9]*$/
          return pattern.test(value) || this.$vuetify.t('$vuetify.AdminCategories.positionIsNotNumeric')
        }
      }
    }
  },

  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        if (value === false) {
          this.$emit('handleClose', value)
        }
      }
    },
    formIconUrl: function () {
      return (this.iconUrl == null || this.iconUrl.length === 0)
        ? './static/img/placeholder_icon.png'
        : this.iconUrl
    },
    isCategoryFormComplete () {
      return this.name && this.position
    }
  },

  components: {
    VueBase64FileUpload,
    FileSizeUploadErrorDialog
  },

  beforeMount: function () {
    if (this.category) {
      // Fill input elems with selected category data
      this.name = this.category.name
      this.description = this.category.description
      this.editingId = this.category.id
      this.image = this.category.image
      this.def = this.category.def
      this.position = this.category.position
    }
  },

  methods: {
    onLoad: function (dataUri) {
      this.image = dataUri
    },
    closeDialog: function () {
      this.showDialog = false
    },
    handleIconSelected: function (icon) {
      if (icon !== undefined) {
        const fr = new FileReader()
        fr.readAsDataURL(icon)
        fr.addEventListener('load', () => {
          this.iconUrl = fr.result
          this.iconFile = icon
          this.iconChanged = true
        })
      } else {
        this.iconFile = ''
        this.iconUrl = ''
      }
    },
    submit: function () {
      this.$validator.validate()
        .then(isFormValid => {
          // Do nothing if validation fails
          if (!isFormValid) {
            return
          }

          const category = {
            school_id: this.$store.getters.selected_school,
            name: this.name,
            description: this.description,
            image: this.image,
            def: this.def,
            position: this.position
          }

          if (this.iconChanged === true) {
            category.icon = this.iconUrl
          }

          // Select the appripriate api depending on whether
          // a category is being added or edited. Also fill
          // in the category id when editing.
          let fn
          if (this.editingId == null) {
            fn = api.category.create
          } else {
            category.id = this.editingId
            fn = api.category.update
          }

          fn(category)
            .then((res) => {
              if (res.status < 400) {
                this.$emit('handleSuccess', true)
              } else {
                this.$emit('handleError', false)
              }
            })
        })
    },
    onSizeExceeded (size) {
      this.$refs.fileSizeUploadErrorDialog.show(size)
    }
  }
}
</script>

<style lang="scss">
.card {
  padding: 10px;
}

.inlineinput {
  display: inline-block;
}

.upload-image-input {
  text-align: left;
}

.upload-image-preview {
  max-width: 90px;
}
</style>
